import { ApplicationState, AppThunkDispatch } from "../store";
import { connect } from "react-redux";
import { getAppointmentsOfCurrentPack, getChangeLog, getChangingState, getChangingValue, isSubmittingNew } from "../store/entities/selectors";
import { deleteOpenEntity, entityCreatingCancel, loadEntities, loadOpenEntityChangeLog, updateChangingEntity, updateEntity, openAppointment } from "../store/entities/actions";
import { PackSettings } from "../models";
import ClientPackForm, { ClientPackFormDispatchProps, ClientPackFormStateProps } from "../components/Forms/ClientPackForm";
import { ClientPackEntity } from "../store/entities/state";
import { deleteClientPackAsync, getAppointmentAsync, getClientPackChangeLogAsync, updateClientPackAsync } from "../ajax/requests";
import { canCreateInvoices, canEditClients, canEditProfessionals, canSeeInvoices, canSeePrices, isAdministrator } from "../store/session/selectors";

interface ClientPackCreateFormOwnProps {
    packSettings?: PackSettings,
}

const mapStateToProps = (state: ApplicationState, props: ClientPackCreateFormOwnProps): ClientPackFormStateProps => {
    const data = getChangingValue(state, 'clientPacks') as ClientPackEntity
    return {
        type: 'edit',
        clientPack: data,
        appointments: getAppointmentsOfCurrentPack(state),
        packSettings: props.packSettings,
        hasChanged: getChangingState(state, 'clientPacks'),
        loading: isSubmittingNew(state, 'clientPacks'),
        canSeePrices: canSeePrices(state),
        canSeeInvoices: canSeeInvoices(state),
        canCreateInvoices: canCreateInvoices(state),
        isAdministrator: isAdministrator(state),
        readOnly: data?.clientIsProfessional ? !canEditProfessionals(state) : !canEditClients(state),
        changeLog: getChangeLog(state, 'clientPacks', getChangingValue(state, 'clientPacks')?.id ?? ''),
    }
}

const mapDispatchToProps = (dispatch: AppThunkDispatch): ClientPackFormDispatchProps => ({
    onLoad: () => {
        dispatch(loadOpenEntityChangeLog<ClientPackEntity>('clientPacks', (data) => getClientPackChangeLogAsync(data.id)));
    },
    onChange: (data: ClientPackEntity) => dispatch(updateChangingEntity('clientPacks', data)),
    onClose: () => dispatch(entityCreatingCancel('clientPacks')),
    onSubmit: (data: ClientPackEntity) => dispatch(updateEntity('clientPacks', data, c => updateClientPackAsync(c))),
    onDelete: () => dispatch(deleteOpenEntity<ClientPackEntity>('clientPacks', data => deleteClientPackAsync(data.clientId, data.id, data.clientIsProfessional ?? false))),
    onLoadAppointment: (appointmentId: string) => 
        dispatch(loadEntities('appointments', () => getAppointmentAsync(appointmentId).then(a => ([a])), 'AppendResult')),
    onOpenAppointment: (appointmentId: string) => dispatch(openAppointment(appointmentId)),
});

export default connect<ClientPackFormStateProps, ClientPackFormDispatchProps, ClientPackCreateFormOwnProps, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(ClientPackForm as any);